require("!!/app/node_modules/script-loader/addScript.js")(require("!!/app/node_modules/raw-loader/index.js!/app/node_modules/bootstrap/dist/js/bootstrap.min.js"))


//////////////////
// WEBPACK FOOTER
// /app/~/script-loader!/app/~/bootstrap/dist/js/bootstrap.min.js
// module id = ../../../../script-loader/index.js!../../../../bootstrap/dist/js/bootstrap.min.js
// module chunks = 15